import { Link } from 'react-router-dom';

const steps = [
  {
    num: '01',
    title: 'Remplissez le formulaire',
    desc: 'Décrivez votre projet en 2 minutes. C\'est gratuit, sans engagement.',
    icon: 'ri-file-text-line',
    duration: '2 min',
  },
  {
    num: '02',
    title: 'On vous rappelle sous 24h',
    desc: 'Échange personnalisé pour cadrer votre projet et valider la conception.',
    icon: 'ri-phone-line',
    duration: '24h max',
  },
  {
    num: '03',
    title: 'Votre site est livré',
    desc: 'Clé en main, 100% optimisé, hébergé et prêt à recevoir vos clients.',
    icon: 'ri-rocket-line',
    duration: '7 jours max',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-slate-50/60">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-xs font-bold text-emerald-500 uppercase tracking-[4px] mb-3">Simple et rapide</p>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-slate-900 mb-4">
            Votre Site en{' '}
            <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">
              3 Étapes
            </span>
          </h2>
          <p className="text-sm sm:text-lg text-slate-500 max-w-xl mx-auto">
            Un processus clair, sans surprise, avec un interlocuteur à chaque étape
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {/* Connecteur desktop */}
              {i < 2 && (
                <div className="hidden md:flex absolute top-12 left-[55%] w-[90%] items-center z-10">
                  <div className="flex-1 border-t-2 border-dashed border-emerald-200"></div>
                  <i className="ri-arrow-right-s-line text-emerald-300 text-xl -ml-1"></i>
                </div>
              )}

              <div className="relative z-20 bg-white rounded-2xl p-6 sm:p-8 border border-slate-100 hover:border-emerald-200 hover:-translate-y-1 transition-all duration-300">
                {/* Numéro */}
                <div className="flex items-center justify-between mb-5">
                  <span className="text-5xl font-black text-emerald-50 select-none">{step.num}</span>
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                </div>

                <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-2">{step.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed mb-4">{step.desc}</p>

                <div className="flex items-center gap-1.5 text-xs font-bold text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-full w-fit border border-emerald-100">
                  <i className="ri-timer-line text-sm"></i>
                  {step.duration}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA centré */}
        <div className="text-center">
          <Link
            to="/demande-devis"
            className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-10 sm:px-14 py-4 sm:py-5 rounded-full text-base sm:text-xl font-black shadow-xl shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-fill text-lg"></i>
            <span>Obtenir Mon Devis Gratuit</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
          <p className="text-xs sm:text-sm text-slate-400 mt-4 font-semibold">
            Sans engagement · Réponse garantie sous 24h · 100% gratuit
          </p>
        </div>
      </div>
    </section>
  );
}
